import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';
import { NewsType } from '@/pages/News/types';
import BasicGuard from '@/routes/middlewares/BasicGuard';

const IndexPage = lazy(() => import('@/pages/News'));
const NewsContentPage = lazy(() => import('@/pages/News/Id'));

const ErrorPage = lazy(() => import('@/pages/Error'));

export interface NewsRoutesProps {
  newsType: NewsType;
}

const NewsRoutes: FC<NewsRoutesProps> = ({ newsType }) => {
  return (
    <Switch>
      <Route
        index
        element={
          <BasicGuard>
            <IndexPage newsType={newsType} />
          </BasicGuard>
        }
      />
      <Route
        path=":id"
        element={
          <BasicGuard>
            <NewsContentPage newsType={newsType} />
          </BasicGuard>
        }
      />

      <Route
        path="*"
        element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
      />
    </Switch>
  );
};

export default NewsRoutes;
